import './Auth.css';
import wall from '../../Assets/Images/RegisterPage/wall.png';
import linkedIn from '../../Assets/Images/RegisterPage/linkedin.png';
import google from '../../Assets/Images/RegisterPage/social.png';

import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RegisterUserUsingEmail } from '../../services/auth';

function RegisterAfterMobile(){
    const navigate = useNavigate();

    const [nameLabel,setNameLabel]=useState("");
    const [emailLabel,setEmailLabel]=useState("");
    const [phoneNumberLabel,setPhoneNumberLabel]=useState("");
    const [passwordLabel,setPasswordLabel]=useState("");
    const [cPasswordLabel,setCPasswordLabel]=useState("");

    const [error,setError]=useState('');

    async function SaveForm(e)
    {
        e.preventDefault();
        var formData=new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        if(!data.name)
        {
            setNameLabel("Name Required!");
        }
        if(!data.email)
            {
                setEmailLabel("Email Required!");
            }
        if(!data.phoneNumber)
            {
                setPhoneNumberLabel("Phone Number Required!");
            }
        if(!data.password)
            {
                setPasswordLabel("Password Required!");
            }
        if(!data.cpassword)
            {
                setCPasswordLabel("Confirm Password Required!");
            }
        if (data.password !== data.cpassword) {
            setCPasswordLabel("Password does not match!")
            return;
        }
        if (!data.name || !data.email || !data.phoneNumber || !data.password || !data.cpassword) {
            return;
        }
        const registered=await RegisterUserUsingEmail(data);
   
        if(registered && registered.token)
        {
            navigate('/profilesetup');
            return;
        }
        else
        {
            setError(registered);
        }
    }

    const passwordRegex=/^(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
    return(
        <>
             <div className='registercontainer'>
                <div className='registerleft_part'>
                   <img src={wall} alt='backgroundImage'/>
                </div>
                <div className='registerright_part' >
                  <img src="" alt='logo' style={{marginTop:"100px"}}/>
                        <h2 style={{marginTop:"150px"}}>Complete Details</h2>
                        {/* <h3>Sign up with your email and password or continue with phone number and social media</h3> */}
                        <form onSubmit={(e)=>SaveForm(e)}>
                            <section className='inputsection'>
                                <div className="inputSubSection">
                                  <input type='text' name='name' placeholder="Name*" className='nameField'
                                    onChange={(e)=>{
                                    if(e.target.value!=="")
                                    {
                                        setNameLabel('');
                                    }}} />
                                  <label className='nameLabel'>{nameLabel}</label>
                                </div>
                                {/* <div className="inputSubSection">
                                    <input type='text' name='phoneNumber' placeholder="Phone Number*" 
                                      onChange={(e)=>{
                                        if(e.target.value!=="")
                                        {
                                            setPhoneNumberLabel('');
                                        }}}/>
                                    <label className='phoneNumberLabel'>{phoneNumberLabel}</label>
                                </div> */}
                                <div className="inputSubSection">
                                  <input type='email' name='email' placeholder="Email*"
                                    onChange={(e)=>{
                                        if(e.target.value!=="")
                                        {
                                            setEmailLabel('');
                                        }}}/>
                                  <label className='emailLabel'>{emailLabel}</label>
                                </div>
                                <div className="inputSubSection">
                                  <input type='text' name='password' placeholder="Password*"
                                  onChange={(e)=>{
                                    if(!passwordRegex.test(e.target.value))
                                    {
                                        setPasswordLabel('Password must include one Uppercase letter, one special character, and at least 8 characters long');
                                    }
                                    else
                                    {
                                        setPasswordLabel('');
                                    }
                                  }}
                                  />
                                  <label className='passwordLabel'>{passwordLabel}</label>
                                </div>
                                <div className="inputSubSection">
                                <input type='password' name='cpassword' placeholder="Password*"
                                  onChange={(e)=>{
                                    if(e.target.value!=="")
                                    {
                                        setCPasswordLabel('');
                                    }}}/>
                                <label className='confirmPasswordLabel'>{cPasswordLabel}</label>
                                </div>
                            </section>
                            <section className='registerbuttons'>
                                <label className='registererror'>{error}</label>
                                <button type="submit" className='registerbutton'>Profile Setup</button>
                                {/* <div className='orsection'>
                                    <hr  class="custom-hr"/>
                                        <h3>OR</h3>
                                    <hr  class="custom-hr"/>
                                </div> */}
                                {/* <button className='continuephone' onClick={()=>navigate('/otpregister')}>CONTINUE WITH PHONE NUMBER</button> */}
                            </section>
                            {/* <section className='socialsignin'>
                                <img src={linkedIn} alt='linkedIn' width="38" height="38"/>
                                <img src={google} alt='linkedIn' width="38" height="38" style={{filter:'grayscale(100%);'}}/>
                            </section>
                            <h4> Already have an account ? <span onClick={()=>navigate('/login')}>Login</span></h4> */}
                    </form>
                </div>
             </div>
        </>
        );

}

export default RegisterAfterMobile;